import { t } from "i18next";
import jsPDF from "jspdf";
import autoTable, { jsPDFDocument, Styles } from "jspdf-autotable";

import { OrderDetails } from "../../orders.types";
import { getProducts } from "./getProducts";

interface renderProductsProps {
  pdf: jsPDF;
  normalFontStyles: Partial<Styles>;
  orderDetails: OrderDetails;
}

export const renderProducts = ({
  pdf,
  normalFontStyles,
  orderDetails
}: renderProductsProps) => {
  const { products } = getProducts({ orderDetails, normalFontStyles });

  autoTable(pdf, {
    theme: "plain",
    startY: (pdf as jsPDFDocument).lastAutoTable.finalY ?? 80,
    styles: { cellPadding: 5 },
    head: [
      [
        {
          content: t("ITEMS ORDERED"),
          styles: {
            valign: "middle",
            halign: "left",
            ...normalFontStyles
          }
        },
        {
          content: t("PRICE"),
          styles: {
            valign: "middle",
            halign: "right",
            ...normalFontStyles
          }
        }
      ]
    ],
    body: products,
    tableLineWidth: 1,
    tableLineColor: "#000000"
  });
};
